import React, { Component } from 'react'
import { Form, Select } from 'antd'
import { SizeProvider, SizeConsumer } from '../../../../context/SizeContext'

export default class MappingSizeForm extends Component {
  render() {
    return (
      <SizeProvider>
        <SizeConsumer>
          {({ fetching, sizes, requestSizeList }) => {
            if (!fetching && !sizes) {
              setTimeout(() => {
                requestSizeList({
                  options: {
                    limit: 9999
                  }
                })
              }, 50)
            }

            const sizesOptions = sizes?.map(size => {
              return {
                label: size.name,
                value: size.key
              }
            }) as any

            return (
              <Form.Item
                label="Size"
                name="size_key"
                rules={[
                  {
                    required: true,
                    message: 'Missing an size'
                  }
                ]}
              >
                <Select
                  loading={fetching}
                  placeholder="Select an size"
                  options={sizesOptions}
                />
              </Form.Item>
            )
          }}
        </SizeConsumer>
      </SizeProvider>
    )
  }
}
